import { GetStaticProps } from "next";
import { useTranslation } from "next-i18next";
import { serverSideTranslations } from "next-i18next/serverSideTranslations";
import { NextSeo } from "next-seo";
import { useRouter } from "next/router";
import { GameLobby } from "@looksrare/poke-the-bear";
import { useCurrentChainInfo } from "@looksrare/utils";
import { getCanonicalAndLanguageAlternates } from "config/seo";
import { WinPageLayout } from "views/win/WinPageLayout";
import { LRPtbProvider } from "components/LRPtbProvider";

const PTBPage = () => {
  const { t } = useTranslation();
  const router = useRouter();
  const currentChainInfo = useCurrentChainInfo();

  const title = "Poke The Bear";
  const description = "Poke The Bear - LooksRare";
  const { canonical, languageAlternates } = getCanonicalAndLanguageAlternates(
    `/poke-the-bear/`,
    router,
    currentChainInfo.appUrl
  );

  return (
    <WinPageLayout isForceDarkMode>
      <NextSeo
        noindex
        nofollow
        title={title}
        description={description}
        openGraph={{
          url: canonical,
          title: t("{{pageTitle}} | LooksRare", { pageTitle: title }),
          description: description,
          images: [
            {
              url: `${currentChainInfo.appUrl}/images/poke-the-bear/meta.png`,
              alt: "Poke The Bear",
              width: 1600,
              height: 900,
              type: "image/png",
            },
          ],
        }}
        canonical={canonical}
        languageAlternates={languageAlternates}
      />
      <LRPtbProvider>
        <GameLobby />
      </LRPtbProvider>
    </WinPageLayout>
  );
};

export const getStaticProps: GetStaticProps = async ({ locale = "en" }) => {
  return {
    props: {
      ...(await serverSideTranslations(locale, ["ptb", "common", "localization", "errors"])),
    },
  };
};

export default PTBPage;
